<template>
  <v-container fluid tag="section" class="px-3">
    <add-number-modal
      :object_id.sync="object_id"
      @closeModal="closeModal"
    >
    </add-number-modal>
    <v-row>
      <!--<v-col class="column left-column py-0">
          <v-card class="tree mb-0 w-100">
              <v-card-text class="card-tree pa-4 pt-10">
                  <v-btn class="card-tree-title" color="primary">Категории звонков</v-btn>
                  <v-treeview
                      class="card-tree-content"
                      v-model="tree"
                      :open="open"
                      :items="menuItems"
                      item-key="name"
                      open-on-click
                      dense
                  />
              </v-card-text>
          </v-card>
      </v-col>-->
      <v-col>
        <!--<v-col class="column right-column py-0 pl-0">-->
        <base-material-card
          inline
          icon="mdi-clipboard-text"
          title="Таблица внутренних номеров IP (сервер: 135.181.84.244:5060)"
          class="px-5 py-3 mb-0 col-sm-12"
        >
          <v-card class="my-0">
            <v-card-title class="pl-0 mb-2">
              <v-text-field
                v-model="search"
                append-icon="search"
                :label="$t('search')"
                color="secondary"
                single-line
                hide-details
                class="search-width"
              ></v-text-field>
            </v-card-title>
          </v-card>
          <v-data-table
            :headers="headers"
            :items="ipNumbers"
            class="caption"
            :mobile-breakpoint="900"
            :page.sync="page"
            @page-count="pageCount = $event"
            :fixed-header="true"
            :height="tableHeight"
            hide-default-footer
            :items-per-page="itemsPerPage"
            hoverable="false"

            @click:row="handleClick"
          >

            <template v-slot:item.id="{ item }">
              <span class="text-overflow caption">{{ item.id }}</span>
            </template>

            <!-- Статус -->
            <template v-slot:item.fullcontact="{ item }">
              <!--<span
                      class="text-overflow caption text-capitalize"
                      :class="{'red&#45;&#45;text': item.fullcontact == 'offline', 'green&#45;&#45;text': item.fullcontact == 'online'}"
              >{{ item.fullcontact }}</span>-->
              <div v-if="item.fullcontact"
                   style="color: #5FA057;">
                Online
              </div>
              <div v-else
                   style="color: red;">
                Offline
              </div>
            </template>

            <!-- Имя -->
            <template v-slot:item.fullname="{ item }">
              <div
                class="d-flex align-center caption position-relative text-capitalize"
              >
                <!--                                <v-avatar size="32" class="mr-2">
                                                    &lt;!&ndash;<img :src="item.url" class="elevation-0"/>&ndash;&gt;
                                                    <img src="https://randomuser.me/api/portraits/men/14.jpg" class="elevation-0"/>
                                                </v-avatar>-->
                <div class="text-left">
                  <span class="text-overflow">{{ item.fullname }}</span>
                </div>
              </div>
            </template>

            <!-- Филиал -->
            <template v-slot:item.branch="{ item }">
              <!--<span class="text-overflow caption">{{ item.branch }}</span>-->
              <span class="text-overflow caption">Днепр</span>
            </template>

            <!-- Внутренний номер -->
            <template v-slot:item.name="{ item }">
<!--                            <span
                              class="text-overflow caption"
                              @click="edit(item.id)"
                            >{{ item.name }}</span>-->

              <span
                class="text-overflow caption"
              >{{ item.name }}</span>
            </template>

            <template v-slot:item.ipaddr="{ item }">
              <span class="text-overflow caption">{{ item.ipaddr }} : {{ item.port }}</span>
            </template>

            <template v-slot:item.device="{ item }">
              <span class="text-overflow caption">{{ item.fullcontact }}</span>
            </template>

            <template
              v-slot:item.action="{}"
            >
              <div
                class="text-overflow caption"
                @click.stop="handleClick"
              >
                <v-btn icon small class="action-button green--text">
                  <v-icon small>mdi-phone</v-icon>
                </v-btn>
                <v-btn icon small class="action-button amber--text">
                  <v-icon small>mdi-email-outline</v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:item.callsHistory="{}">
              <div
                class="text-overflow caption"
                @click.stop="handleClick"
              >
                <v-btn icon small class="action-button indigo--text">
                  <v-icon small>mdi-phone-settings-outline</v-icon>
                </v-btn>
              </div>
            </template>
            <v-data-footer :show-current-page="true"></v-data-footer>
          </v-data-table>

          <div class="text-center mt-3 pagination-block">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="totalVisiblePagination"
              color="#0051ff"
            ></v-pagination>
            <span class="row-options">
                            <label class="mr-2">Показывать строк</label>
                            <v-select
                              :items="rowsOptions"
                              v-model="rows"
                              label
                              dense
                              solo
                              @change="setRows"
                              class="rows-options-select"
                              item-color
                            ></v-select>
                        </span>
          </div>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AddNumberModal from './components/AddNumberModal'

import axios from 'axios'

export default {
  name: 'IpNumbers',

  components: { AddNumberModal },

  data: function () {
    return {
      open: ['public'],
      tree: [],
      search: '',
      tableHeight: 'auto',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      totalVisiblePagination: 7,
      rowsOptions: [3, 5],
      rows: 5,
      isActive: false,

      menuItems: [
        {
          id: 1,
          name: 'Все звонки',
          children: [{ id: 2, name: 'Исходящие' }, { id: 3, name: 'Пропущенные' }],
        }, {
          id: 4,
          name: 'Мои звонки',
          children: [{ id: 5, name: 'Исходящие' }, { id: 6, name: 'Пропущенные' }],
        }, {
          id: 7,
          name: 'Мои группы',
          children: [
            {
              id: 8,
              name: 'Все звонки группы',
              children: [{ id: 9, name: 'Исходящие' }, { id: 10, name: 'Пропущенные' }],
            },
            {
              id: 11,
              name: 'Филиал Днепр',
              children: [{ id: 12, name: 'Исходящие' }, { id: 13, name: 'Пропущенные' }],
            },
            {
              id: 14,
              name: 'Филиал Запорожье',
              children: [{ id: 15, name: 'Исходящие' }, { id: 16, name: 'Пропущенные' }],
            },
          ],
        },
      ],

      headers: [
        {
          text: 'ID',
          value: 'id',
          align: 'center',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'Статус',
          value: 'fullcontact',
          align: 'center',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'Пользователь',
          value: 'fullname',
          align: 'left',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'Филиалы',
          value: 'branch',
          align: 'center',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'Внутренний номер',
          value: 'name',
          align: 'center',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'IP адрес: port',
          value: 'ipaddr',
          align: 'center',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'Устройство',
          value: 'device',
          align: 'center',
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'Действие',
          value: 'action',
          align: 'center',
          sortable: false,
          class: 'text-overflow font-weight-bold caption',
        }, {
          text: 'История звонков',
          value: 'callsHistory',
          align: 'center',
          sortable: false,
          class: 'text-overflow font-weight-bold caption',
        },
      ],

      ipNumbers: [],

      // id - выбраного объекта:
      object_id: -1,
    }
  },

  methods: {
    setRows () {
      this.itemsPerPage = this.rows
    },

    /**
     * Получить список sippeers.
     */
    getListSippeers () {
      axios({
        method: 'get',
        url: process.env.VUE_APP_API_URL_PHONE + 'get-list-sippeers',
      }).then((response) => {

        console.log(response.data)

        this.ipNumbers = response.data

      }).catch(error => alert(error))
    },

    handleClick (value) {
      this.edit(value.id)
    },

    edit (id) {
      console.log('edit(): ' + id)

      this.object_id = id

      //this.$emit('editing', id);
    },

    closeModal () {
      console.log('IpNumbers.closeModal()')

      setTimeout(() => { this.getListSippeers() }, 500)

      this.getListSippeers()

      this.object_id = -1
    },
  },

  created () {
    this.getListSippeers()
  },
}
</script>

<style lang="scss" scoped>
// сетка

.row {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}

.column {
  height: 100%;
}

.left-column {
  flex: 0 0 290px;
}

.right-column {
  min-width: 370px;
}

.v-card {
  border-radius: 4px !important;
}

// левая колонка

.v-card.tree {
  height: calc(100% - 30px);
}

.card-tree {
  position: relative;
  height: 100%;
}

.card-tree-title {
  position: absolute;
  top: -17px;
  width: calc(100% - 32px);
  min-height: 48px;
  font-size: 14px !important;
}

.card-tree-content {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

// правая колонка

.v-card--material {
  height: calc(100% - 30px);
}

.v-data-table {
  height: calc(100% - 160px);
  overflow: auto;
}

// медиазапросы

@media (max-width: 980px) {
  .row-options label {
    display: none !important;
  }
}

@media (max-width: 743px) {
  .v-card.tree {
    height: auto;
  }

  .row {
    height: auto;
  }

  .right-column {
    padding-left: 12px !important;
  }
}

// пагинация в таблице

.pagination-block {
  display: flex;

  .row-options {
    display: flex;
    position: absolute;
    right: 20px;
    align-items: baseline;

    .v-select {
      width: 50px;
    }
  }
}
</style>
